import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractModalContentComponent } from '../../common/modal/abstract-modal-content.component';
import { ModalService } from '../../common/modal/modal.indra.service';
import scrollLock from 'scroll-lock';
import { INDRAApiService } from '@ibe/services';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import * as PromoVoucherActions from '@ibe/store/actions/promo-vouchers.actions';
import * as DeepLinkPriceMismatchActions from '@ibe/store/actions/deeplink-price-mismatch.actions';
import * as FlightInformationActions from '@ibe/store/actions/flight-information.indra.actions'
import * as OutboundFlightInformationActions from '@ibe/store/actions/outbound-flight-information.indra.actions'
import * as InboundFlightInformationActions from '@ibe/store/actions/inbound-flight-information.indra.actions'
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

@Component({
	selector: 'app-navigate-away-modal',
	templateUrl: './navigate-away-modal.indra.component.html',
	styleUrls: ['./navigate-away-modal.component.scss']
})
export class INDRANavigateAwayModalComponent extends AbstractModalContentComponent implements OnInit {
	htmlElement = document.getElementsByTagName('html');

	current_page$: Observable<any> = this.store.select(fromStore.getSelectedBookingCurrentPage);
    current_page: string;
	isLoading: boolean = false;
	isAlive: boolean;
	
	constructor(
		protected modalService: ModalService,
		private router: Router,
		private store: Store<fromStore.State>,
		private apiService: INDRAApiService,
		private storage: INDRAStorageService
	) {
		super(modalService);
		this.TYPE = 'dialog';

		this.current_page$
        .pipe(takeWhile(() => this.isAlive))
        .subscribe(value => {
            this.current_page = value;
        });
	}

	ngOnInit() {
	}



	closeModal() {
		this.modalService.close();
		if (this.htmlElement[0].classList.contains('no-scroll')) {
			if (this.router.url.indexOf('sidebar') < 0) {
				this.htmlElement[0].classList.remove('no-scroll');
				scrollLock.show();
			}
		}
	}

	TAP_handleCancel() {
		if (this.current_page === 'flights') {
		  this.store.dispatch(new FlightInformationActions.ResetAction);
		  this.store.dispatch(new OutboundFlightInformationActions.ResetOutboundFlightInformationAction);
		  this.store.dispatch(new InboundFlightInformationActions.ResetInboundFlightInformationAction);
		}
		
		this.closeModal();
		this.modalService.navigateAwaySelection$.next(false);
	}

	TAP_handleConfirm() {		
		this.store.dispatch(new DeepLinkPriceMismatchActions.ResetAction());
		// do not call signOut API if pnr is already created, otherwise signOut will return an error
		if (!this.storage.get('bookingPnr')) {
			this.isLoading = true;
			this.apiService.INDRA_signOutFromSession().subscribe(res => {
				this.isLoading = false;

				// clear promocodes and vouchers in the store
				this.store.dispatch(new PromoVoucherActions.ResetAction());
				this.closeModal();
				this.modalService.navigateAwaySelection$.next(true);
			}, (error) => {});
		} else {
			this.storage.remove('bookingPnr');

			// clear promocodes and vouchers in the store
			this.store.dispatch(new PromoVoucherActions.ResetAction());
			this.closeModal();
			this.modalService.navigateAwaySelection$.next(true);
		} 
	}

}



